import { BookOpenTextIcon, CalendarCheckIcon, CalendarXIcon, ClipboardCheckIcon, DicesIcon, FileTextIcon, FolderSearchIcon, LayoutGridIcon, LightbulbIcon, PencilRulerIcon, ShapesIcon, ShuffleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
export const PRODUCT_IMAGE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/ebook-images/8aac3fe8-b8d1-444d-b3a3-99d1fadd7893/product-uploads/mcp_833adcbb-8db6-45fd-aed9-603abe229bae_1793021999333.webp';
export const heroGuarantees = ['Одмах на мејл', 'Једнократна уплата', 'Без претплате', '7 дана гаранције'];
export const stats = [{
  value: '240',
  label: 'Страна у главним томовима'
}, {
  value: '6',
  label: 'Дигиталних томова за физичко'
}, {
  value: '8',
  label: 'Разреда – од 1. до 8.'
}, {
  value: '5',
  label: 'Бонуса на поклон'
}, {
  value: '1',
  label: 'Комплетан систем за наставу'
}];
export const differenceStats = [{
  value: '1–8. разред',
  label: 'Материјал организован у три циклуса'
}, {
  value: '6 дигиталних томова',
  label: 'Од годишњег плана до оцењивања'
}, {
  value: 'PDF за штампу',
  label: 'За употребу на екрану или одштампано у сали'
}];
export const beforeItems: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Недеља увече нестаје',
  text: 'Сати пред рачунаром да испланирате часове за следећу недељу – и још нисте готови.'
}, {
  title: 'Сати тражења',
  text: 'Игре и вежбе са разних сајтова су прелаке, претешке или морају да се прилагоде пре часа.'
}, {
  title: 'Припреме пишете од нуле',
  text: 'Циљ, справе, делови часа, минути – оно што би требало да траје пет минута постаје дуг посао.'
}, {
  title: 'Тешко је држати све узрасте',
  text: 'Различити разреди, 25–30 ученика и три нивоа способности у истој сали.'
}, {
  title: 'Оцењивање одузима време',
  text: 'Праћење напретка, провере и оцене постају још један посао после наставе.'
}, {
  title: 'Стрес пред сваки час',
  text: 'Кад нема времена, лако се импровизује – „данас играмо фудбал” и тако из недеље у недељу.'
}];
export const afterItems = ['Организован пакет за физичко од 1. до 8. разреда', 'Часови минут по минут које је лако применити', 'Игре, вежбе и полигони спремни за салу и игралиште', 'Листићи у 3 нивоа за сваки час', 'Оцењивање и праћење напретка на једном месту', 'Више времена за ученике, а мање за папирологију'];
export const recognizeItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: CalendarXIcon,
  title: 'Викенд одлази на планирање',
  text: 'Да ли део викенда проводите у припреми часова физичког за наредну недељу?'
}, {
  icon: FolderSearchIcon,
  title: 'Не знате коју игру да изаберете',
  text: 'Стално тражите игре и вежбе које одговарају узрасту и нивоу ученика?'
}, {
  icon: LightbulbIcon,
  title: 'Желите јасније објашњење вежби',
  text: 'Треба вам више визуелног материјала да покажете технику и правила на једноставан начин?'
}, {
  icon: PencilRulerIcon,
  title: 'Не желите да све правите од нуле',
  text: 'Волели бисте да су часови, игре и листићи већ спремни?'
}, {
  icon: ShuffleIcon,
  title: 'Ученицима треба више разноврсности',
  text: 'Желите више игара, штафета, полигона и изазова на часу?'
}, {
  icon: LayoutGridIcon,
  title: 'Потребна вам је јаснија структура',
  text: 'Желите да вам материјал буде на једном месту да брзо нађете оно што вам треба?'
}];

// Spine colours mirror the physical box (blue, light blue, green, yellow, orange, red).
export const volumes: Array<{
  number: string;
  level: string;
  title: string;
  tagline: string;
  intro: string;
  items: string[];
  outro: string;
  note?: string;
  spine: string;
  rule: string;
}> = [{
  number: 'Том 01',
  level: '1–8',
  title: 'Годишњи план & 12 часова минут по минут',
  tagline: 'Цела школска година на једном месту.',
  intro: 'Први том вам даје годишњи план за сваки циклус и 12 готових часова са листићима.',
  items: ['Годишњи план 1–4, 5–6 и 7–8. разред', 'Полугодиште недељу по недељу', '12 часова минут по минут (45 мин)', 'Уводни, припремни, главни и завршни део', 'Листићи у 3 нивоа', 'Правила и безбедност у сали', 'Излазне картице', 'Шаблон за припрему часа', 'Писмо родитељима'],
  outro: 'Отворите, изаберите час и уђите у салу са планом.',
  spine: 'bg-blue-700 text-white',
  rule: 'border-white/30'
}, {
  number: 'Том 02',
  level: '1–8',
  title: 'Елементарне & штафетне игре',
  tagline: 'Игре које деца обожавају – без припреме.',
  intro: 'Други том доноси игре за загревање, главни део и смиривање, за сваки узраст.',
  items: ['Елементарне игре', 'Штафетне игре', 'Игре са лоптом', 'Игре за загревање', 'Игре смиривања', 'Игре у природи', 'Полигони', 'Варијанте у 3 нивоа', 'Правила и безбедност'],
  outro: 'Готове игре са правилима, справама и шемом сале.',
  spine: 'bg-sky-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Том 03',
  level: '1–8',
  title: 'Спортске игре: фудбал, кошарка, одбојка, рукомет',
  tagline: 'Од првог додавања до праве утакмице.',
  intro: 'Трећи том води ученике корак по корак кроз четири спортске игре.',
  items: ['Фудбал', 'Кошарка', 'Одбојка', 'Рукомет', 'Вежбе технике у паровима', 'Игре у малим групама', 'Шеме терена', 'Правила и суђење', 'Фер-плеј', 'Провере технике'],
  outro: 'Јасни кораци и шеме терена за сваки узраст.',
  spine: 'bg-green-600 text-white',
  rule: 'border-white/30'
}, {
  number: 'Том 04',
  level: '1–8',
  title: 'Атлетика, гимнастика & физичке способности',
  tagline: 'Брзина, снага, издржљивост, гипкост и координација.',
  intro: 'Четврти том обједињује атлетику, вежбе на тлу и справама и кружне тренинге.',
  items: ['Трчање и стартови', 'Скок удаљ и увис', 'Бацање лоптице', 'Колути и вежбе на тлу', 'Прескок и греда', 'Кружни тренинг', 'Вежбе снаге и гипкости', 'Тестови физичких способности', 'Помоћ и чување'],
  outro: 'Корак по корак, са безбедношћу на првом месту.',
  spine: 'bg-yellow-400 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Том 05',
  level: '1–8',
  title: 'Здрав начин живота',
  tagline: 'Здравствено васпитање које ученици разумеју.',
  intro: 'Пети том доноси готове часове и активности о здрављу, исхрани и навикама.',
  items: ['Здрава исхрана', 'Хигијена и сан', 'Пулс и напор', 'Загревање и истезање', 'Држање тела', 'Прва помоћ – основе', 'Кретање у свакодневном животу', 'Листићи и пројекти', 'Активности за родитеље'],
  outro: 'Кратко, јасно и примењиво у сали и у учионици.',
  note: 'Материјал је образовни и не замењује савет лекара.',
  spine: 'bg-orange-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Том 06',
  level: '1–8',
  title: 'Оцењивање & праћење напретка',
  tagline: 'Праведне оцене без додатног стреса.',
  intro: 'Шести том садржи критеријуме, провере и обрасце за праћење сваког ученика.',
  items: ['Критеријуми за оцене 1–5', 'Описно оцењивање у 1. разреду', 'Формативно оцењивање', 'Провере технике', 'Тестирање физичких способности', 'Табеле напретка', 'Самопроцена ученика', 'Коментари за ес-Дневник', 'Обрасци за штампу'],
  outro: 'Све што вам треба за оцењивање – на једном месту.',
  note: 'Самостални наставни материјал; није издање нити одобрење Министарства просвете.',
  spine: 'bg-red-600 text-white',
  rule: 'border-white/30'
}];
export const volumesIntro = {
  title: '6 дигиталних томова за 1–8. разред',
  text: 'Комплетан пакет за физичко и здравствено васпитање који вам помаже да планирате и водите наставу током целе школске године. Сваки том има 40 страна часова, игара, вежби и листића.'
};
export const packItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: BookOpenTextIcon,
  title: 'Готови часови',
  text: 'Нема почетка од празне стране. Часови минут по минут са циљем, справама и реченицама за наставника.'
}, {
  icon: FileTextIcon,
  title: 'Листићи за штампу',
  text: 'Листићи у 3 нивоа које одштампате и одмах користите – за час, понављање и домаћи задатак.'
}, {
  icon: ShapesIcon,
  title: 'Визуелне шеме',
  text: 'Шеме сале и терена, кораци технике и полигони који вежбу чине јасном и лакшом за објашњење.'
}, {
  icon: DicesIcon,
  title: 'Игре и активности',
  text: 'Елементарне и штафетне игре, изазови и полигони који ученицима дају више начина да се крећу.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Оцењивање и решења',
  text: 'Готови критеријуми, провере и решења листића као подршка за оцењивање и праћење.'
}, {
  icon: CalendarCheckIcon,
  title: 'Годишњи план',
  text: 'Подршка да организујете наставу физичког и бирате теме према свом плану.'
}];
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/8aac3fe8-b8d1-444d-b3a3-99d1fadd7893/1793022219636_fiz-tom1-p05-d249b5be.webp",
    "label": "Годишњи план · Страна 5",
    "title": "Годишњи план 1–4. разред",
    "text": "Табела месец по месец, од септембра до јуна, са темом и часом из тома за сваки месец."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/8aac3fe8-b8d1-444d-b3a3-99d1fadd7893/1793022223842_fiz-tom1-p12-3251d756.webp",
    "label": "Час 1 · Страна 12",
    "title": "Игра „Семафор”",
    "text": "Час минут по минут за 1. разред: циљ, справе, упутство за наставника и безбедност."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/8aac3fe8-b8d1-444d-b3a3-99d1fadd7893/1793022228239_fiz-tom1-p13-182da0b2.webp",
    "label": "Листић · Страна 13",
    "title": "Моје тело у покрету",
    "text": "Листић у 3 нивоа за штампу, са решењима на дну стране."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/8aac3fe8-b8d1-444d-b3a3-99d1fadd7893/1793022232735_fiz-tom1-p24-2f631111.webp",
    "label": "Час 7 · Страна 24",
    "title": "Кружни тренинг: 6 станица",
    "text": "Шема сале са шест станица, минутима рада и прелаза и упутством за наставника."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/8aac3fe8-b8d1-444d-b3a3-99d1fadd7893/1793022237149_fiz-tom1-p26-609c3f4f.webp",
    "label": "Час 8 · Страна 26",
    "title": "Колут напред",
    "text": "Кораци учења у сликама, припремне вежбе, помоћ и чување за 6. разред."
  }
];
export const pageTypes = ['Готови часови', 'Листићи за штампу', 'Игре и вежбе', 'Оцењивање и решења'];
export const bonuses: Array<{
  title: string;
  text: string;
  items: string[];
  benefit: string;
}> = [{
  title: 'Загревање за 5 минута',
  text: 'Готова загревања за сваки час и сваки узраст – без размишљања шта данас радимо на почетку.',
  items: ['Загревања за 1–8. разред', 'Динамичке вежбе', 'Игре за загревање', 'Варијанте за салу и игралиште'],
  benefit: 'Сваки час почиње организовано, за пет минута.'
}, {
  title: 'Школски спортски дан',
  text: 'Комплетан план спортског дана: станице, игре, распоред, дипломе и подела задужења.',
  items: ['План и распоред', 'Станице и игре', 'Дипломе за штампу', 'Листа за организацију'],
  benefit: 'Спортски дан без стреса и импровизације.'
}, {
  title: 'Комуникација са родитељима',
  text: 'Готове поруке и писма за родитеље о опреми, оправдањима, оценама и такмичењима.',
  items: ['Писма за почетак године', 'Поруке за ес-Дневник и Viber групу', 'Оправдања и здравље', 'Родитељски састанак'],
  benefit: 'Мање времена за поруке, јасна сарадња са породицом.'
}, {
  title: 'Замена на часу физичког без стреса',
  text: 'Готови часови које може да одржи и колега на замени – јасно, кратко и безбедно.',
  items: ['12 часова за замену', 'Упутства корак по корак', 'Игре без много справа', 'Безбедност на првом месту'],
  benefit: 'Одсуство без бриге – час иде даље.'
}, {
  title: 'Плакати за фискултурну салу',
  text: 'Шарени плакати за салу: правила, рутине, загревање, фер-плеј и здраве навике.',
  items: ['Правила у сали', 'Рутине и сигнали', 'Фер-плеј', 'Здраве навике'],
  benefit: 'Сала која сама подсећа ученике на правила.'
}];
export const steps: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Отворите ФИЗИЧКО СПРЕМНО™',
  text: 'Преузмите пакет и отворите том за свој разред.'
}, {
  title: 'Изаберите час и материјал',
  text: 'Нађите тему и изаберите час, игре или листиће који одговарају вашим ученицима.'
}, {
  title: 'Припремите се за 5 минута',
  text: 'Прођите кроз упутство и изаберите справе и листиће који вам требају.'
}, {
  title: 'Одштампајте и водите час',
  text: 'Одштампајте листиће или користите материјал на екрану – и уђите у салу са јасним планом.'
}];
export const audienceItems = ['Предајете физичко и здравствено васпитање од 1. до 4., 5–6. или 7–8. разреда', 'Желите целу школску годину часова спремну унапред', 'Губите викенде на припреме и тражење игара', 'Желите више разноврсности на часу', 'Желите јасне критеријуме за оцењивање', 'Желите више времена за ученике, а мање за папире'];
export const timeValueTasks = ['Тражење игара и вежби', 'Писање припрема', 'Цртање шема сале и терена', 'Припрема листића', 'Оцењивање и праћење напретка'];
export const offerRows: Array<{
  label: string;
  detail: string;
}> = [{
  label: '6 дигиталних томова – 240 страна',
  detail: 'Годишњи план, игре, спортске игре, атлетика и гимнастика, здравље и оцењивање'
}, {
  label: '5 бонуса без доплате',
  detail: 'Загревање, спортски дан, родитељи, замена и плакати за салу'
}, {
  label: 'За 1–8. разред',
  detail: 'Готови часови, листићи и решења'
}];
export const offerIncludes = ['Одмах на мејл', 'PDF фајлови које чувате', 'Листићи за штампу', 'Физички производ се не шаље'];
export const PRICE = '2.490 дин.';

// Only add authentic reviews of ФИЗИЧКО СПРЕМНО. The section stays hidden while empty.
export const testimonials: Array<{
  quote: string;
  name: string;
  location: string;
}> = [];
export const faqs = [{
  q: 'Како добијам материјал?',
  a: 'ФИЗИЧКО СПРЕМНО™ стиже дигитално. После куповине добијате приступ PDF фајловима које можете да преузмете и сачувате. Материјал користите на рачунару, таблету или телефону и штампате листиће који вам требају.'
}, {
  q: 'Да ли је ФИЗИЧКО СПРЕМНО™ прилагођено школи у Србији?',
  a: 'Да. Материјал је направљен за наставу физичког и здравственог васпитања у основној школи у Србији, по областима програма. То је самостални наставни материјал, а не издање нити одобрење Министарства просвете.'
}, {
  q: 'Да ли одговара за 1–8. разред?',
  a: 'Да. Шест томова је организовано по циклусима – 1–4, 5–6 и 7–8. разред. Бирате материјал према разреду и теми коју предајете.'
}, {
  q: 'Да ли стварно могу да припремим час за 5 минута?',
  a: 'ФИЗИЧКО СПРЕМНО™ је направљено да припрему убрза. Отворите том, изаберете готов час и прођете кроз њега за око пет минута. Време зависи од садржаја часа, одељења и потребе за прилагођавањем.'
}, {
  q: 'Да ли материјал траје целу школску годину?',
  a: 'Да. ФИЗИЧКО СПРЕМНО™ садржи часове, игре и активности за целу школску годину. Бирате, комбинујете и прилагођавате их свом годишњем плану и ученицима.'
}, {
  q: 'Има ли готових листића?',
  a: 'Да. Материјал садржи листиће за штампу у 3 нивоа, са задацима, сликама и решењима.'
}, {
  q: 'Да ли су решења укључена?',
  a: 'Да. Пакет садржи решења листића и критеријуме као подршку за проверу и оцењивање.'
}, {
  q: 'Могу ли да га користим за ученике различитих нивоа?',
  a: 'Да. Игре, вежбе и листићи имају варијанте у 3 нивоа које бирате и прилагођавате знању и способностима ученика.'
}, {
  q: 'Морам ли све да штампам?',
  a: 'Не. Сами бирате које стране штампате, а део материјала можете да користите на екрану.'
}, {
  q: 'Да ли је пет бонуса укључено?',
  a: `Да. Свих пет бонуса је у пакету без доплате – све за ${PRICE}.`
}, {
  q: 'Да ли је ово претплата?',
  a: 'Не. Плаћате једном и добијате приступ дигиталном материјалу. Нема месечних трошкова.'
}, {
  q: 'Могу ли да сачувам фајлове?',
  a: 'Да. PDF фајлове можете да преузмете и сачувате за даљу употребу према условима коришћења производа.'
}, {
  q: 'Могу ли да користим материјал на телефону или таблету?',
  a: 'Да. PDF фајлови се отварају на рачунару, таблету и телефону. За преглед листића пре штампе препоручујемо рачунар или таблет.'
}, {
  q: 'Постоји ли гаранција?',
  a: 'Да. ФИЗИЧКО СПРЕМНО™ има гаранцију задовољства од 7 дана. Ако материјал не испуни ваша очекивања, можете нас контактирати и затражити повраћај новца у гарантном року, према условима.'
}];
export const footerLinks = ['Услови куповине', 'Политика приватности', 'Политика повраћаја', 'Контакт'];
